import { Grid } from "@mui/material"
import styles from "./AddFarmBillingEntity.module.scss"
import Dropdown from "../../components/DropDown"
import { customStyle } from "../../styles/serviceAgreement"
import { useAddFarm } from "../../hooks/useAddFarmBillingEntity"
export const FarmDetails = () => {
       const {
        newFarmData,
        farmDetailsError,
        billingEntityError,
        cropYearError,
        farmNameOptions,
        billingEntityOptions,
        cropYearOptions,
        handlefarmNameDropdownChange,
        handleBillingEntityChange,
        handlecropYearChange,
        handleSaveFarmDetails,
        handleCancel
    } = useAddFarm()
    return (
        <div className={styles.formContainer}>
            <Grid container spacing={2} >
                <Grid item xs={12} sm={6} md={4}>
                <Dropdown
                        label="Landlord"
                        value={newFarmData.farmName ? farmNameOptions.find((opt) => opt.value === newFarmData.farmName) : null}
                        options={farmNameOptions}
                        customStyles={{...customStyle,menuList:(provided)=>({
                            ...provided,
                            maxHeight:"100px"
                        })}}
                        isClearable
                        isDisabled={false}
                        placeholder="Select Landlord"
                        onChange={handlefarmNameDropdownChange}
                        error={!!farmDetailsError}
                        helperText={farmDetailsError}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Dropdown
                        label="Billing Entity"
                        value={newFarmData.billingEntity ? billingEntityOptions.find((opt) => opt.value === newFarmData.billingEntity) : null}
                        options={billingEntityOptions}
                        customStyles={{...customStyle,menuList:(provided)=>({
                            ...provided,
                            maxHeight:"100px"
                        })}}
                        isClearable
                        isDisabled={false}
                        placeholder="Select Billing Entity"
                        onChange={handleBillingEntityChange}
                        error={!!billingEntityError}
                        helperText={billingEntityError}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Dropdown
                        label="Calendar Year"
                        value={newFarmData.cropYear ? cropYearOptions.find((opt) => opt.value === newFarmData.cropYear) : null}
                        options={cropYearOptions}
                        customStyles={{...customStyle,menuList:(provided)=>({
                            ...provided,
                            maxHeight:"100px"
                        })}}
                        isClearable
                        isDisabled={false}
                        placeholder="Select Calendar Year"
                        onChange={handlecropYearChange}
                        error={!!cropYearError}
                        helperText={cropYearError}
                    />
                </Grid>
            </Grid>
            <div className={styles.buttonContainer} style={{marginTop:'1rem'}}>
                <button className={styles.cancelButton} onClick={handleCancel}>
                    Cancel
                </button>
                <button className={styles.saveButton} onClick={handleSaveFarmDetails}>
                    Add
                </button>
            </div>
        </div>
    );
};